import { render, staticRenderFns } from "./vue-draggable-resizable.vue?vue&type=template&id=148ed060&scoped=true"
import script from "./vue-draggable-resizable.vue?vue&type=script&lang=js"
export * from "./vue-draggable-resizable.vue?vue&type=script&lang=js"
import style0 from "./vue-draggable-resizable.vue?vue&type=style&index=0&id=148ed060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148ed060",
  null
  
)

export default component.exports